export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 scroll-mt-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
          关于触手漫画
        </h2>
        <div className="bg-background-100 rounded-2xl p-8 md:p-10 border border-background-200/60">
          <div className="w-16 h-16 mx-auto mb-5 flex items-center justify-center bg-primary-100 text-primary-500 rounded-2xl">
            <i className="ri-book-read-line text-2xl"></i>
          </div>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-2xl mx-auto">
            触手漫画网诞生于对触手题材漫画的热爱。我们致力于为触手漫画爱好者打造最优质的免费在线阅读平台，
            汇集了来自世界各地的优秀触手漫画作品。无论你是触手漫画的忠实粉丝，还是刚刚接触这一独特题材的新读者，
            这里都有适合你的精彩内容。从热血战斗到温馨日常，从悬疑惊悚到奇幻冒险，
            触手漫画网用丰富多元的内容和流畅的下拉式阅读体验，让每一位读者都能沉浸在触手漫画的精彩世界中。
          </p>
        </div>
      </div>
    </section>
  );
}